<section class="page-top-section">
  <div class="container">
    <div class="title-second">
      <h1>{{ titleData }}</h1>
    </div>
  </div>
</section>
